import { createFileRoute } from "@tanstack/react-router";
import { MultilingualServiceLanding } from "@/components/MultilingualServiceLanding";
import { DE_APOSTILLE } from "@/data/de-service-content";
import { SEO_SITE, multiHreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const PATH = "/de/apostille";
const C = DE_APOSTILLE;

export const Route = createFileRoute("/de/apostille")({
  head: () => ({
    meta: [
      { title: ctaTitle("Apostille in Thailand — MFA-Beglaubigung | NYC Legal", "/de/apostille", "th")},
      { name: "description", content: ctaDesc("Apostille des thailändischen MFA (Haager Übereinkommen) in 5–7 Werktagen. Beeidigte Übersetzung DE↔TH. Talk to a specialist today; no obligation, fast reply.", "/de/apostille", "th")},
      { property: "og:title", content: ctaTitle("Apostille in Thailand | NYC Legal", "/de/apostille", "th")},
      { property: "og:description", content: ctaDesc("Beidseitige Apostille DE↔TH. Notar, Übersetzung, MFA, Botschaft — aus einer Hand.", "/de/apostille", "th")},
      { property: "og:url", content: `${SEO_SITE}${PATH}` },
      { property: "og:locale", content: "de_DE" },
    ],
    links: [
      { rel: "canonical", href: `${SEO_SITE}${PATH}` },
      ...multiHreflangLinks(
        [
          { hreflang: "th-TH", path: "/apostille" },
          { hreflang: "en", path: "/en/apostille" },
          { hreflang: "zh", path: "/zh/apostille" },
          { hreflang: "ja", path: "/ja/apostille" },
          { hreflang: "ko", path: "/ko/apostille" },
          { hreflang: "ru", path: "/ru/apostille" },
          { hreflang: "de", path: "/de/apostille" },
          { hreflang: "x-default", path: "/apostille" },
        ],
        "/apostille",
      ),
    ],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "LegalService",
        name: "NYC Legal — Apostille (DE)", url: `${SEO_SITE}${PATH}`,
        areaServed: ["TH", "DE", "AT", "CH"], inLanguage: "de",
        priceRange: "฿1,500–฿5,000",
        provider: { "@type": "LegalService", name: "NYC Language Institute", url: SEO_SITE },
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "FAQPage", inLanguage: "de",
        mainEntity: C.faqs.map((f) => ({ "@type": "Question", name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a } })),
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "HowTo", inLanguage: "de",
        name: C.stepsH2, step: C.steps.map((s, i) => ({
          "@type": "HowToStep", position: i + 1, name: s.name, text: s.text })),
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Startseite", item: `${SEO_SITE}/de` },
          { "@type": "ListItem", position: 2, name: "Apostille", item: `${SEO_SITE}${PATH}` },
        ],
      }) },
    ],
  }),
  component: () => <MultilingualServiceLanding c={C} />,
});
